import { styled, Tab } from '@mui/material';

export const StyledChannelTab = styled(Tab)`
  text-transform: none;
  font-size: 16px;
  padding: 9px;
  min-height: 50px;
  color: rgba(0, 0, 0, 0.38);
`;
